export const allStateTypes =  [
  {text: 'Active', value: 1},
  {text: 'InActive', value: 0},
];